import type { StaffKey } from './staffText'

/** The word on a person's row for why they cannot sign in with the right
 *  password. One word each, because the row is a list, and the Unlock beside it
 *  is the explanation. */
export function standingTag(
  standing: 'locked' | 'dormant' | undefined,
  say: (key: StaffKey) => string,
): string | undefined {
  if (standing === 'locked') return say('admin.people.locked')
  if (standing === 'dormant') return say('admin.people.asleep')
  return undefined
}
